import PageWithHero from "../components/legal/PageWithHero";
import RichTextContent from "../components/ui/RichTextContent";
import useSEO from "../hooks/useSEO";
import seoConfig from "../config/seoConfig";
import { generateWebPageSchema } from "../utils/schemaGenerators";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { getLegalPage } from "../services/legalServices";

export default function AboutPage() {
  const { i18n, t } = useTranslation();
  const [page, setPage] = useState(null);

  useEffect(() => {
    let cancel = false;
    getLegalPage("about", i18n.language)
      .then((res) => {
        if (!cancel) setPage(res);
      })
      .catch(() => {
        if (!cancel) setPage(null);
      });
    return () => {
      cancel = true;
    };
  }, [i18n.language]);

  const title = page?.title || t("legalPages.about.title");
  const subtitle = page?.subtitle || t("legalPages.about.subtitle");

  const seo = useSEO({
    title,
    description: subtitle,
    schema: generateWebPageSchema({
      name: title,
      description: subtitle,
      url: `${seoConfig.siteUrl}/about`,
    }),
  });

  return (
    <>
      {seo}
      <PageWithHero title={title} subtitle={subtitle}>
        {page?.bodyHtml ? (
          <RichTextContent html={page.bodyHtml} />
        ) : (
          <>
            <p>{t("staticPages.about.p1")}</p>
            <p>{t("staticPages.about.p2")}</p>
          </>
        )}
      </PageWithHero>
    </>
  );
}
